import { GIGS_STATUS, STATUS_OPTIONS } from "./gigsClaimConstants";

export type StatusOption = typeof STATUS_OPTIONS[number]["value"];

export function isStatusOption(v: string): v is StatusOption {
  return STATUS_OPTIONS.some(opt => opt.value === v);
}

function assertNever(value: never): never {
  throw new Error(`Unhandled StatusOption: ${String(value)}`);
}

export function matchesStatus(gigStatus: number | undefined, filter: StatusOption): boolean {
  switch (filter) {
    case "all":
      return true;
    case "not-verified":
      return gigStatus === GIGS_STATUS.NOT_VERIFIED;
    case "processed":
      return (
        gigStatus === GIGS_STATUS.PROCESSED_PENDING
        || gigStatus === GIGS_STATUS.PROCESSED_COMPLETE
        || gigStatus === GIGS_STATUS.PROCESSED_PARTIAL
      );
    case "ineligible":
      return gigStatus === GIGS_STATUS.INELIGIBLE;
    case "rejected":
      return gigStatus === GIGS_STATUS.REJECTED;
    case "archived":
      return gigStatus === GIGS_STATUS.ARCHIVED;
    default:
      return assertNever(filter);
  }
}
